const t = "_wrapper_yv055_1", o = "_icon_yv055_9", n = "_button_yv055_15", _ = {
  wrapper: t,
  icon: o,
  button: n
};
export {
  n as button,
  _ as default,
  o as icon,
  t as wrapper
};
